export default __webpack_public_path__ + "static/media/close_blue.97e60069.svg";